import React from "react";
import { Row, Col, Checkbox, Typography, Dropdown, Select } from "antd";
import { DownOutlined } from "@ant-design/icons";
import { useFormContext, Controller } from "react-hook-form";
import { useNotificationsState } from "../State";
const { Text } = Typography;
import translator from "@/translator";
const t = translator("front_office.views.altegio_notification_settings.");

export const validation = (formValues, _state) => {
  const { filters = {} } = formValues;
  const {
    booking_cats_enabled,
    booking_cats,
    service_cats_enabled,
    service_cats,
    client_cats_enabled,
    client_cats,
    staff_cats_enabled,
    staff_cats,
  } = filters;

  return (
    (!booking_cats_enabled || booking_cats?.length > 0) &&
    (!service_cats_enabled || service_cats?.length > 0) &&
    (!client_cats_enabled || client_cats?.length > 0) &&
    (!staff_cats_enabled || staff_cats?.length > 0)
  );
};

const FilterCategory = ({ name }) => {
  const { control, setValue, watch } = useFormContext();
  const { state } = useNotificationsState();
  const isEnabled = watch(`filters.${name}_enabled`);
  const label = t(`fields.filters.${name}`);
  const placeholder = t(`fields.filters.${name}_placeholder`);

  const modeOptions = {
    items: state.filters.cats_modes,
    onClick: ({ key }) => setValue(`filters.${name}_mode`, key),
  };

  const options = state.filters.cats_values[state.selectedSalon]?.[name] ?? [];

  const valueToLabel = (value) => {
    return modeOptions.items.find((item) => item.key === value).label;
  };

  return (
    <div className="altegio-notification-settings-create__filters_cats-i">
      <Controller
        control={control}
        name={`filters.${name}_enabled`}
        defaultValue={false}
        render={({ field: { onChange, value } }) => (
          <div className="altegio-notification-settings-create__filters_cats-mode">
            <Checkbox checked={value} onChange={onChange}>
              {label}
            </Checkbox>

            <Controller
              control={control}
              name={`filters.${name}_mode`}
              defaultValue={"allow"}
              render={({ field: { value } }) => (
                <Dropdown overlayClassName="ant-custom-dropdown" menu={modeOptions}>
                  <div>
                    <span>{valueToLabel(value)}</span>
                    <DownOutlined />
                  </div>
                </Dropdown>
              )}
            />
          </div>
        )}
      />

      <Controller
        control={control}
        name={`filters.${name}`}
        defaultValue={[]}
        render={({ field: { onChange, value } }) => (
          <Select
            value={value}
            onChange={onChange}
            size="large"
            disabled={!isEnabled}
            className="ant-custom-select"
            popupClassName="ant-custom-select-dropdown"
            style={{ width: "100%" }}
            mode="multiple"
            optionFilterProp="label"
            options={options}
            placeholder={placeholder}
          />
        )}
      />
    </div>
  );
};

const FilterCategories = () => {
  return (
    <Row>
      <Col sm={24} xl={11}>
        <Text strong>{t("fields.filters.cats")}</Text>
      </Col>
      <Col sm={0} xl={2} />
      <Col sm={24} xl={11} className="altegio-notification-settings-create__adv-settings-group">
        <FilterCategory name="booking_cats" />
        <FilterCategory name="service_cats" />
        <FilterCategory name="client_cats" />
        <FilterCategory name="staff_cats" />
      </Col>
    </Row>
  );
};

export default FilterCategories;
